import { spacing, animations, sizes, borders, backgrounds, boxShadows, palette } from './palette';
import breakpoints, { breakpointSizes } from './breakpoints';
import colors from './colors';
import fonts from './fonts';
import { pipe, defaultTo, mergeDeepRight } from 'ramda';

const theme = {
  animations,
  backgrounds,
  borders,
  boxShadows,
  breakpoints,
  breakpointSizes,
  colors,
  fonts,
  palette,
  sizes,
  spacing,
};

export const createTheme = pipe(defaultTo({}), mergeDeepRight(theme));
